/**
 * @author Mohit Kukreja <mohit.kukreja@314ecorp.com>
 * @description Favorite Codes Icon
 */

/**
 * Favorite Codes Icon
 */
const FavoriteCodesIcon: React.FC = () => {
	return (
		<span className='anticon anticon-icon'>
			<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 20 24' fill='none' aria-label='Favourites'>
				<path
					d='M2 1H18C18.552 1 19 1.448 19 2V21.5L10 16L1 21.5V2C1 1.448 1.448 1 2 1Z'
					stroke='currentColor'
					strokeWidth='2'
					strokeLinejoin='round'
				/>

				<path
					d='M10 5.5L11.2 8H14L11.8 9.8L12.6 12.5L10 11L7.4 12.5L8.2 9.8L6 8H8.8L10 5.5Z'
					stroke='currentColor'
					strokeWidth='1.5'
					strokeLinejoin='round'
					strokeLinecap='round'
				/>
			</svg>
		</span>
	);
};

export default FavoriteCodesIcon;
